export enum CorrespondenceType {
  In = 1,
  Out = 2
}
